import React from 'react';

const getCautions = (metric, content) => {
  switch (metric) {
    case 'total':
      return {
        strengths: content.total.strengths,
        weaknesses: content.total.weaknesses,
      };
    case 'total_per_pop':
      return {
        strengths: content.totalPerPop.strengths,
        weaknesses: content.totalPerPop.weaknesses,
      };
    case 'average':
      return {
        strengths: content.averageDaily.strengths,
        weaknesses: content.averageDaily.weaknesses,
      };
    case 'change':
      return {
        strengths: content.averageChange.strengths,
        weaknesses: content.averageChange.weaknesses,
      };
  }
};

const Cautions = (props) => {
  const { content, metric } = props;
  const cautions = getCautions(metric, content);
  return (
    <div className='cautions asideBox'>
      <div className='strengths'>
        <h4>{content.strengths}</h4>
        <p>{cautions.strengths}</p>
      </div>
      <div className='weaknesses'>
        <h4>{content.weaknesses}</h4>
        <p>{cautions.weaknesses}</p>
      </div>
    </div>
  );
};

export default Cautions;
